import { makeAutoObservable, runInAction } from "mobx";
import agent from "../api/agent";
import { IEmailConfig } from "../interfaces/IEmailConfig";
import { historys } from "../..";
import Swal from "sweetalert2";
import { AnyAsyncThunk } from "@reduxjs/toolkit/dist/matchers";

export default class EmailConfigStore {
  emailConfig: IEmailConfig | null = null;
  testSendMail = false;
  //   emailConfig: IEmailConfig[] = [];
  editMode = false;
  loading = false;
  submitting = false;
  constructor() {
    makeAutoObservable(this);
  }
  SendEmailTypeChecking = async (e:IEmailConfig) => {
    this.loading = true;
    try {
      const result = await agent.EmailConfig.SendEmailTypeChecking(e);
      runInAction(() => {
        if (result) {
          console.log(result);
          this.testSendMail = true;
          this.loading = false;
        }
      });
      return true;
    } catch (error) {
      console.log(error);
      runInAction(() => (this.loading = false));
      return false;
    }
  };
}
